// extracted by mini-css-extract-plugin
export default {"block":"styles_block__GofKg","navItem":"styles_navItem__WcF5N","navItem_active":"styles_navItem_active__8uehM","item":"styles_item__DbVFt","item_active":"styles_item_active__NTvgQ"};